<div class="modal-header">
  <h3>{{ title }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body h-100 d-flex flex-column">
  <div class="row">
    <div class="col">
      <ul class="vive-blue_list">
        <li>Click on any row to edit that vendor.</li>
        <li>
          Rows highlighted in <span class="error-red fw-semibold">RED</span> are
          missing required information. ({{ missingRequiredFieldVendorCount }})
        </li>
        <li>
          Rows highlighted in <span class="yellow fw-semibold">YELLOW</span> are
          vendors matching existing vendors. ({{ duplicateVendorCount }})
        </li>
        <li>
          Rows highlighted in <span class="pink fw-semibold">PINK</span> share
          the same tax id with another vendor in the list. ({{
            sharedTaxIdVendorCount
          }})
        </li>
      </ul>
    </div>
  </div>

  @if (selectedRows.length > 0 && CompanyComplianceTypes.length > 0) {
    <div class="row mb-3 align-items-end">
      <div class="col">
        <label class="form-label" for="bulk-company-compliance-type">
          Compliance program for selected vendors
        </label>
        <select
          id="bulk-company-compliance-type"
          class="form-select"
          [(ngModel)]="selectedCompanyComplianceType"
        >
          <option disabled [ngValue]="undefined">Pick one…</option>
          @for (item of CompanyComplianceTypes; track item.id) {
            <option [ngValue]="item">
              {{ item.type }}
            </option>
          }
        </select>
      </div>
      <div class="col">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!selectedCompanyComplianceType"
          (click)="applyComplianceTypeToSelectedRows()"
          title="Apply the selected compliance program to every selected vendor"
        >
          Apply to {{ selectedRows.length }} Selected Vendor{{
            selectedRows.length !== 1 ? 's' : ''
          }}
        </button>
      </div>
    </div>
  }

  @if (apConfigSelectionMap.size > 0) {
    <div class="row mb-3">
      <div class="col">
        <label class="form-label">
          Create these vendors in accounting system(s)
          <span class="text-muted fw-normal"
            >— optional; leave empty to skip</span
          >
        </label>
        <app-multi-select
          [Items]="apConfigSelectionMap"
          [inputSelectedItems]="selectedApConfigIdsMap"
          [disabled]="(selectedApConfigIds?.length ?? 0) > 0"
          (selectedItemsChange)="apConfigSelectionChange($event)"
        ></app-multi-select>
      </div>
    </div>
  }

  @if (
    missingRequiredFieldVendorCount > 0 ||
    duplicateVendorCount > 0 ||
    sharedTaxIdVendorCount > 0
  ) {
    <div class="row mb-2">
      <div class="col d-flex gap-2">
        @if (missingRequiredFieldVendorCount > 0) {
          <button
            type="button"
            class="btn btn-danger btn-sm"
            (click)="removeRedRows()"
            title="Remove all vendors missing required information"
          >
            Remove {{ missingRequiredFieldVendorCount }} Red Row{{
              missingRequiredFieldVendorCount !== 1 ? 's' : ''
            }}
          </button>
        }
        @if (duplicateVendorCount > 0) {
          <button
            type="button"
            class="btn btn-warning btn-sm"
            (click)="removeYellowRows()"
            title="Remove all duplicate vendors"
          >
            Remove {{ duplicateVendorCount }} Yellow Row{{
              duplicateVendorCount !== 1 ? 's' : ''
            }}
          </button>
        }
        @if (sharedTaxIdVendorCount > 0) {
          <button
            type="button"
            class="btn btn-pink btn-sm"
            (click)="removePinkRows()"
            title="Remove all vendors sharing a tax id with another vendor in the upload"
          >
            Remove {{ sharedTaxIdVendorCount }} Pink Row{{
              sharedTaxIdVendorCount !== 1 ? 's' : ''
            }}
          </button>
        }
      </div>
    </div>
  }

  <div class="row flex-grow-1" style="min-height: 400px">
    <div class="col">
      <app-company-vendors-grid
        [gridName]="'AdminClientRegisteredVendorUpload'"
        [rowModelType]="'clientSide'"
        [gridPrimaryKeyFieldName]="'rowId'"
        [rowData]="rowData"
        [rowSelectionType]="'multiple'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [suppressFieldDotNotation]="false"
        [rowClassRules]="rowClassRules"
        (rowSelectionChanged)="rowSelectionChanged($event)"
        (actionEvent)="actionEvent($event)"
        [(reloadGridData)]="reloadGrid"
      ></app-company-vendors-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="upload()">
      Upload
    </button>
  </div>
</div>
